// @ts-strict-ignore
export class ConnectionAreaSearchVectorVO {

  public id: number = -1;
  public searchForMultipleGivingConnections: boolean;
  public searchForFreedomConnectionTarget: boolean = false;
  public globalRequirementIndices: number[];
  // key: global requirement index, value: list of additional properties
  public additionalPropertiesMap: any;
  public excludedArticleTypes: string[];
}
